// src/pages/FormPage/renderers/SpaRenderer.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import * as babel from 'babel-standalone';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import { FormImage, MaskWidget, ActionButtonWidget } from '../widgets';
import axios from 'axios';

/**
 * Renderiza formulário usando layout SPA customizado
 */
const SpaRenderer = ({
  spaLayout,
  functions,
  formSchema,
  uiSchema,
  formData,
  onSubmit,
  onChange,
  disabled
}) => {
  const customFields = { image: FormImage };
  const customWidgets = { MaskWidget, ActionButtonWidget };
  try {
    const babelCode = babel.transform(spaLayout, { presets: ['react', 'es2015'] }).code;
    const code = babelCode.replace(/['"]use strict['"];?/, '').trim();
    const renderFn = new Function(
      'React',
      'Helmet',
      'Form',
      'formSchema',
      'uiSchema',
      'formData',
      'validator',
      'customFields',
      'customWidgets',
      'disabled',
      'onSubmit',
      'onChange',
      'log',
      'axios',
      `return ${code}`
    );

    return renderFn(
      React,
      Helmet,
      Form,
      formSchema,
      uiSchema,
      formData,
      validator,
      customFields,
      customWidgets,
      disabled,
      onSubmit,
      onChange,
      console.log,
      axios
    );
  } catch (err) {
    console.error('Erro ao interpretar SPA Layout', err);
    return <div className="text-red-500 p-4">Erro ao carregar layout SPA.</div>;
  }
};

export default SpaRenderer;
